import React, { Component, Fragment } from "react";
import "./Footer.css";
import { injectIntl } from "react-intl";
import emi_logo_footer from "../../img/emi_logo_footer.svg";
import messages from "./messages";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleLink = (link) => {
    // window.location.href = link;
    window.open(
      link,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  render() {
    const { formatMessage } = this.props.intl;
    const { company, style } = this.props;
    return (
      <Fragment>
        <div className="footer-container">
            <div className="logo-footer-container" style={style && style.footerBackgroundColor ? { background: style.footerBackgroundColor } : null}>
              {company.company_logo_footer ? (
                <>
                <div className="footer-client-logo-container-first"></div>
              <div className="footer-client-logo-container">
                <img
                  src={company.company_logo_footer}
                  alt="Company Name"
                  className="footer-client-logo"
                />

              </div></>
              ) : null}
              {company.socialNetworkLinks ? <div className="footer-client-logo-social-container">
                <div className="footer-client-logo-social-title">
                  {formatMessage(messages.footer.findUs)}
                </div>
                <div className="footer-client-logo-social-logos">
                  {company.socialNetworkLinks.tikTok ? <div className="footer-client-logo-social-logo">
                    <a
                      href={company.socialNetworkLinks.tikTok}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="https://emi-public.s3.amazonaws.com/static/walmart/Logos/tiktok.svg" alt="tiktok" />
                    </a>
                  </div> : null}
                  {company.socialNetworkLinks.facebook ? <div className="footer-client-logo-social-logo">
                    <a
                      href={company.socialNetworkLinks.facebook}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="https://emi-public.s3.amazonaws.com/static/walmart/Logos/facebook.svg" alt="facebook" />
                    </a>
                  </div> : null}
                  {company.socialNetworkLinks.instagram ? <div className="footer-client-logo-social-logo">
                    <a
                      href={company.socialNetworkLinks.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="https://emi-public.s3.amazonaws.com/static/walmart/Logos/instagram.svg" alt="instagram" />
                    </a>
                  </div> : null}
                  {company.socialNetworkLinks.linkedin ? <div className="footer-client-logo-social-logo">
                    <a
                      href={company.socialNetworkLinks.linkedin}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="https://emi-public.s3.amazonaws.com/static/mercado-libre/Icono+LinkedIn+(2).svg" alt="linkedIn" />
                    </a>
                  </div> : null}
                </div>
              </div> : null}
            </div>
          


          <div className="emi-footer-container">
            <div className="emi-footer-made">
              {formatMessage(messages.footer.madeWith)}
              <div className="emi-logo-footer">
              <img
                src={emi_logo_footer}
                alt="Emi Logo"
                width={30}
                height='auto'
              />
              </div>
            </div>
            <div>{formatMessage(messages.footer.allRightsReserved)}</div>
            <div>
              <a
                href="https://www.emilabs.ai/politica-de-privacidad"
                target="_blank"
                className="footer-privacy-policy-link"
                rel="noreferrer"
              >
                {formatMessage(messages.footer.privacyPolicy)}
              </a>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default injectIntl(Footer);
